import { isStructureFinding, type FindingType } from '@ast-data/shared';

/**
 * What a Planum or Profil records that only ONE kind of Befund shows. Both
 * kinds store every field, so switching the type hides these rather than
 * dropping them (see FindingPlanumFormDialog / FindingProfileFormDialog).
 */
const ORDINARY_ONLY_FIELDS = [
    'length',
    'width',
    'diameter',
    'depth',
    'differenceToPreviousPlanum',
    'strata',
    'colors',
    'soilType',
    'inclusions',
    'consistency',
    'boundaryClarity',
    'boundaryBasis',
    'contour',
    'humusContent'
];

const STRUCTURE_ONLY_FIELDS = [
    'courses',
    'excavationMethod',
    'fills',
    'filledBy',
    'interpretation'
];

function hasValue(value: unknown): boolean {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return typeof value === 'string' && value.trim() !== '';
}

/** The kind a Befund switches to — there are only two. */
export function otherFindingType(type: FindingType): FindingType {
    return isStructureFinding(type) ? 'description' : 'structure';
}

/**
 * How many of a Befund's descriptions hold something the form of `nextType`
 * no longer shows — the number the confirmation names.
 */
export function countDescriptionsHidingData(
    descriptions: readonly object[],
    nextType: FindingType
): number {
    const hiddenFields = isStructureFinding(nextType)
        ? ORDINARY_ONLY_FIELDS
        : STRUCTURE_ONLY_FIELDS;
    return descriptions.filter((description) =>
        hiddenFields.some((field) =>
            hasValue((description as Record<string, unknown>)[field])
        )
    ).length;
}
